import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { dateToText } from '../components/application/global.function';
import aggrQuery from '../helpers/aggrQueryParams';
import {
    ICalendarData,
    IDep,
    IDoctor,
    IFilial,
    IRecTalon,
    IRecTalonInit,
    IResponseClinicInfo,
    IResponseLaterPayment,
    IRnumbDate,
    ISpec,
    IStaticFilter,
    ITalonInfo,
    ITalonInfoExtraDBResponse,
    ITalonResAppointment,
    ITalonResAttrs,
    ITalonIntervalResult,
    ITalonResCPbyR,
    ITalonsDaySetParams,
} from '../interfaces/record.interfaces';
import { HttpNewService } from './application/http-new.service';
import { AuthService } from './auth.service';
import { EventService } from './event/event.service';
import { Store } from './store.service';
import { CookieConsentService } from './cookie-consent/cookie-consent-service';

@Injectable({
    providedIn: 'root',
})
export class RecordService {
    public constructor(
        private httpNew: HttpNewService,
        private auth: AuthService,
        private cookieService: CookieConsentService,
        private eventService: EventService,
    ) {}
    /* События календаря */
    public CalendaryinitSubject = new Subject<ICalendarData>();
    public CalendarysetParams(param: ICalendarData) {
        // Установить параметры для календаря
        if (this.CalendaryinitSubject) {
            this.CalendaryinitSubject.next(param);
        }
    }
    // Событие инициализации
    public CalendaryonInit$(): Observable<ICalendarData> {
        return this.CalendaryinitSubject.asObservable();
    }
    // ******************************************************
    /* События талонов */
    public TalonsInitSubject = new Subject<IRecTalonInit>();
    public TalonsSetParams(param: IRecTalonInit) {
        // Передать список талонов
        if (this.TalonsInitSubject) {
            this.TalonsInitSubject.next(param);
        }
    }
    // Событие инициализации списка талонов
    public TalonsOnInit$(): Observable<IRecTalonInit> {
        return this.TalonsInitSubject.asObservable();
    }

    public TalonsDayInitSubject = new Subject<ITalonsDaySetParams>();
    public TalonsDaySetParams(param: ITalonsDaySetParams) {
        // Передать выбранные день
        if (this.TalonsDayInitSubject) {
            this.TalonsDayInitSubject.next(param);
        }
    }
    // Событие инициализации списка талонов
    public TalonsDayOnInit$(): Observable<ITalonsDaySetParams> {
        return this.TalonsDayInitSubject.asObservable();
    }
    // *****************************************************
    /* События выбор талонов*/
    public RnumbDateinitSubject = new Subject<IRnumbDate>();
    public RnumbDateSetParams(param: IRnumbDate) {
        // Установить параметры для Блок Rnumb
        if (this.RnumbDateinitSubject) {
            this.RnumbDateinitSubject.next(param);
            this.eventService.emit('calendar:loading');
        }
    }
    // Событие инициализации
    public RnumbDateOnInit$(): Observable<IRnumbDate> {
        return this.RnumbDateinitSubject.asObservable();
    }

    /* События списка подразделений */
    public DepInitSubject = new Subject<IDep[]>();
    public DepSetParams(param: IDep[]) {
        // Установить параметры для Блок Rnumb
        if (this.DepInitSubject) {
            this.DepInitSubject.next(param);
        }
    }
    // Событие инициализации
    public DepOnInit$(): Observable<IDep[]> {
        return this.DepInitSubject.asObservable();
    }

    // Событие Выбора Dep
    public DepSelectSubject = new Subject<IDep>();
    public DepSelect(param: IDep) {
        // Установить параметры для Блок Rnumb
        if (this.DepSelectSubject) {
            this.DepSelectSubject.next(param);
        }
    }
    // Событие Выбора
    public DepOnSelect$(): Observable<IDep> {
        return this.DepSelectSubject.asObservable();
    }

    /**
     * Список специальностей
     * @param parameters
     * beginDate: Date,
     * endDate: Date
     * staticId - id фильтра
     */
    public getSpecList(
        beginDate: Date,
        endDate: Date,
        stacId: number | null,
        depId?: number | null,
    ): Observable<Array<ISpec>> {
        let url = '/record/spec/list';
        if (beginDate && endDate) {
            url =
                url +
                `?beginDate=${dateToText(beginDate)}&endDate=${dateToText(
                    endDate,
                )}`;
        }
        if (stacId) {
            url = url + `&stacId=${stacId}`;
        }
        if (depId) {
            url = url + `&depId=${depId}`;
        }
        return this.httpNew.get<Array<ISpec>>(url);
    }

    public getFilialList(): Observable<IFilial[]> {
        let url = '/record/filial/list';
        return this.httpNew.get<Array<IFilial>>(url);
    }

    /**
     * Список докторов
     * @param parameters
     */
    /*
  public getHistoryEvents(pStart?: number , pEnd?: number): Observable<IHistoryEvents[]> {
    let url = '/history/events';
    if (pStart && pEnd) {
      url = url + `?start=${pStart}&end=${pEnd}`;
    }
*/

    public getDocList(
        pSpecId: number,
        beginDate: Date,
        endDate: Date,
        stacId: number | null,
        depId: number | null,
        signal: AbortSignal | undefined,
    ): Observable<Array<IDoctor>> {
        let url = '/record/doc/list';
        const params = {
            specId: pSpecId,
            beginDate: dateToText(beginDate),
            endDate: dateToText(endDate),
            stacId: stacId,
            depId: depId,
        };
        // if (pSpecId && beginDate && endDate) {
        //     url =
        //         url +
        //         `?specId=${pSpecId}&beginDate=${dateToText(
        //             beginDate,
        //         )}&endDate=${dateToText(endDate)}`;
        // }
        // if (stacId) {
        //     url = url + `&stacId=${stacId}`;
        // }
        // if (depId) {
        //     url = url + `&depId=${depId}`;
        // }
        return this.httpNew.get<Array<IDoctor>>(
            url,
            params,
            undefined,
            null,
            signal,
        );
    }

    public getRnumbList(
        pDoctorId: number,
        pSpecId: number | null,
        beginDate: Date,
        endDate: Date,
        stacId: number | null,
        srvIds: string | null,
    ): Observable<IRecTalon[]> {
        const url = '/record/rnumb/list';
        const params = {
            specId: pSpecId,
            doctorId: pDoctorId,
            beginDate: dateToText(beginDate),
            endDate: dateToText(endDate),
            stacId,
            srvIds,
        };
        return this.httpNew.get<Array<IRecTalon>>(url, params);
    }

    /* Список фильтров кнопок (метки на талонах) */
    public getStacfilterList(): Observable<Array<IStaticFilter>> {
        const url = '/record/stacfilter/list';
        return this.httpNew.get<Array<IStaticFilter>>(url);
    }

    /* Список подразделений */
    public getDepList(
        pDoctorId: number,
        pSpecId: number | null,
        srvId: number | null,
    ): Observable<Array<IDep>> {
        const url = '/record/dep/list';
        const params = { doctorId: pDoctorId, specId: pSpecId, srvId: srvId };
        return this.httpNew.get<Array<IDep>>(url, params);
    }

    /* Информация о талоне */
    public getRnumbInfo(
        rnumbId: number | null,
        srvId: string | null = null,
    ): Observable<Array<ITalonInfo>> {
        const url = '/record/rnumb/info';
        const params = { rnumbId, srvId };
        return this.httpNew.get<Array<ITalonInfo>>(url, params);
    }

    /* Блокировка талона */
    public setRnumbBlStatus(rnumbId: number): Observable<void> {
        let url = '/record/rnumb/blstatus';
        const params = { rnumbId };
        return this.httpNew.get<void>(url, params);
    }

    /* Запись талона */
    public setAppointment(
        rnumbId: number,
        srvId: number | null,
    ): Observable<ITalonResAppointment> {
        const url = '/record/rnumb/appointment';
        const queryParams: Record<string, number | null> = {
            rnumbId,
            customerId: this.cookieService.getParentCookieData(),
            srvId,
        };

        return this.httpNew.get<ITalonResAppointment>(url, queryParams);
    }

    public setAppointmentExtra(
        docdepId: number,
        srvIds: string,
        date: string,
    ): Observable<ITalonResAppointment> {
        // console.log(date);
        const url = '/record/rnumb/appointment-extra';
        const data: Record<string, number | null | string> = {
            docdepId,
            srvIds,
            date,
            customerId: this.cookieService.getParentCookieData(),
        };
        return this.httpNew.post<ITalonResAppointment>(url, data);
    }

    /* Проверка статусов талона */
    public getAttrs(
        rnumbId: number,
        srvId: number | null,
    ): Observable<ITalonResAttrs> {
        const url = '/record/rnumb/attrs';
        const queryParams = { rnumbId, srvId };
        return this.httpNew.get<ITalonResAttrs>(url, queryParams);
    }

    /* Создание платежа после записи на номерок */
    public getCPbyR(
        rnumbId: number,
        srvId: number | null,
    ): Observable<ITalonResCPbyR> {
        const url = '/record/rnumb/cpbyr';
        const queryParams = {
            rnumbId,
            srvId,
            customerId: this.cookieService.getParentCookieData(),
        };
        return this.httpNew.get<ITalonResCPbyR>(url, queryParams);
    }

    /* Создание Видео-конференции после записи на номерок */
    public getСreateConference(rnumbId: number): Observable<any> {
        const url = '/trueconf/create_conference';
        // url = url + `?rnumbID=${rnumbID}`;
        const params = { rnumbId };
        return this.httpNew.get<void>(url, params);
    }

    /* Оплата отложенного платежа */
    public getPaymentTemp(
        paymentId: number,
        email: string | null,
        phone: string | null,
    ): Observable<IResponseLaterPayment> {
        const url = '/record/rnumb/paymenttemp';
        const params = {
            paymentId,
            email,
            phone,
        };
        return this.httpNew.get<IResponseLaterPayment>(url, params);
    }

    /* Отмена талона */
    public getRnumbCancel(rnumbId: number): Observable<void> {
        const url = '/record/rnumb/cancel';
        const queryParams = {
            rnumbId,
            customerId: this.cookieService.getParentCookieData(),
        };
        return this.httpNew.get<void>(url, queryParams);
    }

    /* Разблокировка талона талона */
    public getRnumbUnlock(rnumbId: number): Observable<void> {
        const url = '/record/rnumb/unlock';
        const params = { rnumbId };
        return this.httpNew.get<void>(url, params);
    }

    /* создание интервального расписания */
    public getRnumbCreateInterval(
        intervalId: number | null,
        dat_bgn: string,
        dat_end: string,
    ): Observable<ITalonIntervalResult> {
        const url = '/record/rnumb/create/interval';
        const params = {
            intervalId: intervalId,
            datBgn: dat_bgn,
            datEnd: dat_end,
        };
        return this.httpNew.post<ITalonIntervalResult>(url, params);
    }

    // FOR REFACTORED CALENDAR
    public getRnumbListv2(params: IRnumbDate) {
        let url = '/record/rnumb/list';
        const {
            specId,
            doctorId,
            periodStart,
            periodEnd,
            staticFilterSelected,
            depId,
        } = params;

        const normalizedParams = aggrQuery({
            specId: specId,
            doctorId: doctorId,
            beginDate: dateToText(periodStart),
            endDate: dateToText(periodEnd),
            stacId: staticFilterSelected?.keyId,
            srvIds: params.srv?.keyId,
            depId: depId,
        });

        return this.httpNew.get<Array<IRecTalon>>(url, normalizedParams);
    }

    public getDepListv2(params: IRnumbDate) {
        const url = '/record/dep/list';

        const normalizedParams = {
            doctorId: params.doctorId,

            specId: params.specId,
            servId: params.srv?.keyId,
        };

        return this.httpNew.get<Array<IResponseClinicInfo>>(
            url,
            aggrQuery(normalizedParams),
        );
    }

    public getRnumbInfoExtra(params: {
        docdepId: number;
        date: Date;
        srvIds: string;
    }) {
        const url = '/record/rnumb/info-extra';

        return this.httpNew.get<ITalonInfoExtraDBResponse>(
            url,
            aggrQuery(params),
        );
    }
}
